<template>
    <div>
        <h1>{{ $t('pages.password_forgotten.title') }}</h1>
        <div class="form-group">
            <label class="col-form-label" for="username">
                {{ $t('pages.password_forgotten.placeholder_username') }}
            </label>
            <div class="input-group mb-3">

                <input type="text" class="form-control"
                       :placeholder="$t('pages.password_forgotten.placeholder_username')"
                       name="username" id="username" v-model="username" ref="username" dusk="username">
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-user-alt"></span>
                    </div>
                </div>
            </div>
        </div>

        <form v-if="mechanismAvailable && !mustUseSSP" @submit.prevent="" dusk="mechanismAvailable">
            <div class="input-group mb-3">
                <div class=""> {{ $t('pages.password_forgotten.reset_mechanisms') }}:</div>
            </div>
            <div class="form-group">
                <div class="input-group mb-3" v-if="mechanisms.email">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="frmResetMechanism"
                               id="frmResetMechanismEmail" value="email" v-model="mechanism"/>
                        <label class="form-check-label"
                               for="frmResetMechanismEmail">{{
                                $t('pages.password_forgotten.reset_mechanism_email')
                            }}</label>
                    </div>
                </div>
                <div class="input-group mb-3" v-if="mechanism === 'email'">
                    <input type="text" class="form-control"
                           :placeholder="$t('pages.password_forgotten.placeholder_email')"
                           name="frmReset_email" id="frmReset_email">
                    <span class="input-group-append">
                            <button type="button" class="btn btn-primary btn-flat" id="frmReset_email_click"
                                    v-on:click="resetBy()">
                                 <span class="fas fa-arrow-right">&nbsp;</span>
                            </button>
                        </span>
                </div>
            </div>
            <div class="form-group">
                <div class="input-group mb-3" v-if="mechanisms.sms">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="frmResetMechanism"
                               id="frmResetMechanismSms" value="sms" v-model="mechanism"/>
                        <label class="form-check-label"
                               for="frmResetMechanismSms">{{
                                $t('pages.password_forgotten.reset_mechanism_sms')
                            }}</label>
                    </div>
                </div>
                <div class="input-group mb-3" v-if="mechanism === 'sms'">
                    <input type="text" class="form-control"
                           :placeholder="$t('pages.password_forgotten.placeholder_sms')"
                           name="frmReset_sms" id="frmReset_sms">
                    <span class="input-group-append">
                            <button type="button" class="btn btn-primary btn-flat" id="frmReset_sms_click"
                                    v-on:click="resetBy()">
                                <span class="fas fa-arrow-right">&nbsp;</span>
                            </button>
                        </span>
                </div>
            </div>
        </form>

        <div v-if="mustUseSSP">
            <div class="mb-3 callout callout-warning" v-html="$t('pages.password_forgotten.mustUseSSP')">
            </div>
        </div>

        <div v-html="$t('pages.password_forgotten.no_mechanism', {link: contact_url})">
        </div>

        <div class="d-flex flex-column">
            <div class="d-flex justify-content-center">
                <a href="/login" id="password_lost">{{ $t('pages.password_forgotten.back_to_login') }}</a>
            </div>
        </div>
    </div>

</template>

<script>
import LoadingInjector from "../../mixins/LoadingInjector";

export default {
    mixins: [
        LoadingInjector
    ],
    props: {
        regexAccount: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            username: '',
            mechanisms: {
                sms: false,
                email: false,
            },
            mechanism: '',
            contact_url: '',
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandlerForResponder;
    },
    mounted() {
        console.log('Mounted Forgot.');

    },
    methods: {
        resetBy: function () {
            this.axios.post(this.$Bologna.secure_url(`/v1/reset-by/${this.mechanism}/${this.username}`), {
                value: jQuery(`#frmReset_${this.mechanism}`).val(),
            })
                .then(response => {
                    window.location = '/initiate-reset';
                })
                .catch(error => {

                });
        }
    },
    computed: {
        mechanismAvailable: function () {
            return this.mechanisms.sms || this.mechanisms.email;
        },
        mustUseSSP: function () {
            return this.username.length === 8 && this.username.startsWith('zz');
        }
    },
    watch: {
        username: _.debounce(function (val, oldval) {
            let regex = new RegExp(`^${this.regexAccount}$`);
            let isOK = regex.test(val)

            this.mechanisms = {
                sms: isOK,
                email: isOK,
            };

        }),
    },
};
</script>
